import { ds } from "js/core/models/dataService";
import { TestRecorderUI } from "js/editor/TestRunner/testRecorder";
import { $ } from "js/vendor";
import debug from "js/core/debug";

export function getEditorDebugMenu() {
    const presentationId = ds.selection.presentation.get("id");

    return {
        overwriteTriggerHandler: true,
        items: [
            { value: "show_test_runner", label: "Show Test Runner" },
            { type: "divider" },
            { value: "debug_player", label: "Open in Player" },
            { value: "debug_embedded_player", label: "Open in Embedded Player" },
            // { value: "debug_renderer", label: "Open in Renderer" }, // TODO
            { type: "divider" },
            { value: "debug_show_layout", label: "Show Layout" },
            // { value: "debug_toggle_profiler", label: window.baiProfiler.isEnabled() ? "Diable Profiler" : "Enable Profiler" },
            { type: "divider" },
            { value: "debug_hide_menu", label: "Hide Debug Button" },
        ],
        callback: action => {
            switch (action) {
                case "show_test_runner":
                    let testRunner = new TestRecorderUI();
                    $("body").before(testRunner.render().$el);
                    break;
                case "debug_player":
                    window.open("/player" + window.location.pathname, "_blank");
                    break;
                case "debug_embedded_player":
                    window.open("/testing/embed/" + presentationId, "_blank");
                    break;
                case "debug_renderer":
                    window.open("/renderer" +
                        "?rendererjsUrl=" + encodeURIComponent(window.location.origin + "/bundle/renderer.js") +
                        "&renderercssUrl=" + encodeURIComponent(window.location.origin + "/bundle/renderer.css") +
                        "&vendorjsUrl=" + encodeURIComponent(window.location.origin + "/bundle/vendor.js"),
                    "_blank");
                    // TODO: need to get path to static assets (not window.location.origin)
                    // TODO: need to init appropriate messages to show the current slide
                    break;
                case "debug_show_layout":
                    debug.showLayout();
                    break;
                case "debug_toggle_profiler":
                    if (window.baiProfiler.isEnabled()) {
                        window.baiProfiler.disable();
                        window.location.reload();
                    } else {
                        window.baiProfiler.enable();
                        window.location.reload();
                    }
                    break;
                case "debug_hide_menu":
                    // used by QA for screenshots
                    this.$el.find("#debug").hide();
                    break;
            }
        }
    };
}

